import React from 'react'

const Whatsapp = () => {
  console.log("Whatsapp component called")

  return (
    <div className="page-wrapper">
      <div className="content">
        Hello from Whatsapp
      </div>
    </div>
  )
}

export default Whatsapp